import axios from '@/plugins/axios'
import jsonToFormData from '@/services/jsonToFormData'
import qs from 'qs'

export default {
  isPublishable (productId, product) {
    return axios.post(`/products/${productId}/is-publishable`, { ...product })
  },
  create (product) {
    return axios.post('/products', product)
  },
  getLatLng (search) {
    return axios.get('/geo/lat-lng', { params: { search } })
  },
  createNews (idProduct, news) {
    const formData = jsonToFormData(news)
    return axios.post(`/products/${idProduct}/news`, formData.data, formData.config)
  },
  createVerticalSite (productId, params) {
    const formData = jsonToFormData(params)
    return axios.post(`/products/${productId}/vertical-sites`, formData.data, formData.config)
  },
  delete (productId) {
    return axios.delete(`/products/${productId}`)
  },
  deleteVerticalSite (productId, verticalSiteProductId) {
    return axios.delete(`/products/${productId}/vertical-sites/${verticalSiteProductId}`)
  },
  exportSubProducts (productId, productType) {
    return axios.get(`/products/${productId}/sub-products-export/${productType}`)
  },
  get (productId) {
    return axios.get(`/products/${productId}`)
  },
  getUserRetailers (productId, params) {
    return axios.get(`/products/${productId}/users-retailers`, { params })
  },
  getAssociations (productId, associationType, locale) {
    return axios.get(`/products/${productId}/associations`, {
      params: {
        locale,
        type: associationType,
        resultsPerPage: 100
      }
    })
  },
  getBookletFile (productId) {
    return axios.get(`/products/${productId}/get-booklet-file`)
  },
  getSubProductImportDemo (productId, productType) {
    return axios.get(`/products/${productId}/sub-products-import-demo/${productType}`)
  },
  getNews (params) {
    const urlParams = qs.stringify(params, { addQueryPrefix: true })
    return axios.get(`/products/${params.productId}/news${urlParams}`)
  },
  getNewsById ({ productId, newsId, locale }) {
    return axios.get(`/products/${productId}/news/${newsId}?locale=${locale}`)
  },
  getHistory (params) {
    const urlParams = qs.stringify(params, { addQueryPrefix: true })
    return axios.get(`/products/${params.productId}/history${urlParams}`)
  },
  getVerticalSite (productId, verticalSiteId) {
    return axios.get(`/products/${productId}/vertical-sites/${verticalSiteId}`)
  },
  getVerticalSites (params) {
    return axios.get(`/products/${params.productId}/vertical-sites`, {
      params: {
        page: params.page,
        resultsPerPage: params.resultsPerPage,
        product: params.productId,
        unlimited: params.unlimited
      }
    })
  },
  importSubProducts (productId, productType, file) {
    const formData = jsonToFormData(file)
    return axios.post(`/products/${productId}/sub-products-import/${productType}`, { import: file }, formData.config)
  },
  save (productId, product) {
    return axios.patch(`/products/${productId}`, product)
  },
  saveAssociation (productId, association) {
    return axios.patch(`/products/${productId}/associations`, association)
  },
  saveBooklet (productId, booklet) {
    booklet._method = 'patch'
    const obj = jsonToFormData(booklet, {}, { nullsAsUndefineds: true })
    return axios.post(`/products/${productId}/booklet`, obj.data, obj.config)
  },
  saveUserRetailers (productId, userRetailerIds) {
    return axios.patch(`/products/${productId}/users-retailers`, { userRetailerIds })
  },
  saveVariants (productId, variants) {
    return axios.patch(`/products/${productId}`, { variants })
  },
  search (params) {
    return axios.get('/products?' + qs.stringify(params))
  },
  searchAssociations (productId, params) {
    const urlParams = qs.stringify(params, { addQueryPrefix: true, skipNulls: true })
    return axios.get(`/products/${productId}/associations${urlParams}`)
  },
  setPublishStatus (productId, refStatusSlug) {
    return axios.post(`/products/${productId}/set-publish-status`, { refStatusSlug })
  },
  importTemplateBoost() {
    return axios.get('/products/boost-demo')
  },
  setBoost (file) {
    const formData = jsonToFormData(file)
    return axios.post(`/products/boost`, { boost: file }, formData.config)
  },
  importTagsDemo () {
    return axios.get('/products/import-tags-demo')
  },
  importTags (file) {
    const formData = jsonToFormData({ tagsFiles: file })
    return axios.post('/products/import-tags', formData.data, formData.config)
  },
  exportTags () {
    return axios.get('/products/export-tags')
  },
  updateNews (productId, newsId, payload) {
    payload._method = 'patch'
    const formData = jsonToFormData(payload)
    return axios.post(`/products/${productId}/news/${newsId}`, formData.data, formData.config)
  },
  updateVerticalSite (productId, verticalSiteId, payload) {
    payload._method = 'patch'
    const formData = jsonToFormData(payload)
    return axios.post(`/products/${productId}/vertical-sites/${verticalSiteId}`, formData.data, formData.config)
  }
}
